import styled from 'styled-components'

export const StyledWrapper = styled.div`
    position: relative;
    min-height: ${props => props.fullHeight ? '100vh' : 'auto'};
`
